import React from "react";
import { Download } from "lucide-react";
import { Button } from "../../../tailwind/button";
import { waBtn } from "../../../../pages/whatsapp/utils/whatsappUiTokens";

export const InvoiceActionButton = ({ invoice, isDownloading, downloadingInvoiceId, onDownload, onPay }) => {
  const hasValidInvoiceId = invoice.invoiceId && invoice.invoiceId !== "N/A";

  if (invoice.status === "paid" && hasValidInvoiceId) {
    return (
      <Button
        variant="ghost"
        size="sm"
        className={`h-8 gap-2 ${waBtn.link} hover:bg-[hsl(158,48%,36%)]/10 transition-colors cursor-pointer`}
        onClick={() => onDownload(invoice)}
        disabled={isDownloading && downloadingInvoiceId === invoice.id}
      >
        <Download className="h-4 w-4" />
        {isDownloading && downloadingInvoiceId === invoice.id ? "Downloading..." : "Download"}
      </Button>
    );
  }

  if (!hasValidInvoiceId) {
    return null;
  }

  return (
    <Button
      size="sm"
      className={`h-8 ${waBtn.primary} transition-colors`}
      onClick={() => onPay(invoice.id)}
    >
      Pay Now
    </Button>
  );
};
